import { RequestType } from 'models/productsReferential';
import { TradeWay } from 'models/TradeWay';
import { connect } from 'react-redux';
import { getQuoteType } from 'state/quotes/selectors';
import { isLiveQuote } from 'state/quotes/utils';
import {
  getFormInfos,
  getFormQuoteState,
  getFormRequestType,
  getFormWorkflowStatus,
  getModifiedTabCandidates,
  getPriceEnhancementMode,
  getSidePanelTradeWayOrDefault,
  getTradeConfirmation,
  hasAddonAction,
} from 'state/selectors';
import type { ModifiedTabCandidate } from 'state/selectors/common/modified-tabs-info';
import { getQuoteExternalIdByWorkspaceTab } from 'state/selectors/common/temp';
import type { ActionButtonsType } from 'state/selectors/meta/quote/utils';
import { getSidePanelActions } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  className?: string;
  tabId: string;
  workspaceType: 'static' | 'dynamic';
}

export interface StateProps {
  hasPriceEnhancer: boolean;
  hasValidationErrors: boolean;
  hasTutorialLink: boolean;
  quoteId?: string;
  isTrading: boolean;
  actions: ActionButtonsType;
  hasTradeAuthorizationErrors: boolean;
  tradeWay: TradeWay;
  displayHelpCenter?: boolean;
  hasAddonAction: boolean;
  requestType?: RequestType;
  modifiedTabCandidates: readonly ModifiedTabCandidate[];
}

export type MainTabContentProps = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const externalQuoteId = getQuoteExternalIdByWorkspaceTab(state, workspaceType, tabId);
  const formInfos = getFormInfos(state, workspaceType, tabId);
  const confirmation = getTradeConfirmation(state, workspaceType, tabId);
  const status = getFormWorkflowStatus(state, workspaceType, tabId);
  const priceEnhancement = getPriceEnhancementMode(state, workspaceType, tabId);
  const hasTradeAuthorizationErrors = status === 'TRADE_AUTH_REJECTED';
  const quoteState = getFormQuoteState(state, workspaceType, tabId);
  const quoteId = formInfos?.quoteId;

  const quoteType = getQuoteType(state, quoteId);
  const isLive = isLiveQuote(quoteState);
  const isTrading = (isLive && confirmation?.isTrading) ?? false;

  const tradeWay = getSidePanelTradeWayOrDefault(state, tabId);
  return {
    hasPriceEnhancer: isLive && status === 'QUOTED_TRADABLE' && priceEnhancement !== 'None',
    hasValidationErrors: !!formInfos?.validationErrors,
    hasTradeAuthorizationErrors,
    hasTutorialLink: workspaceType === 'static' && externalQuoteId === undefined,
    hasAddonAction: hasAddonAction(state, tabId, workspaceType),
    quoteId,
    isTrading,
    actions: getSidePanelActions(quoteType, status, confirmation),
    displayHelpCenter: status === 'ERROR' || status === 'REJECTED',
    tradeWay,
    requestType: getFormRequestType(state, workspaceType, tabId),
    modifiedTabCandidates: getModifiedTabCandidates(state, workspaceType, tabId),
  };
};

export const connectMainTabContent = connect(mapStateToProps);
